import config from '@/config';
import { apiPublicInstance } from '../API';
import { PlatformService } from './types';

export interface Rule {
  category: number;
  points: number;
  pointType: number;
  threshold: number;
  frequency: number;
  label: string;
}

export const getPlatformServices = async (): Promise<PlatformService[]> => {
  return (await apiPublicInstance().get(`/api/platforms/${config.platformUuid}/servicesDetails?withRevokedCriteria=true`)).data;
};
